import { ConfigTypes } from '../actions/configAction';

const defaultState = {
  isLoadingConfig: true,
  permission: {},
  generalConfig: {},
  notificationConfig: {},
  systemConfig: {},
  landingPageConfig: {
    staticConfigLoading: true,
    value: []
  },
  navMenuConfig: {
    menu: {},
    stickyMenu: false,
    homeIcon: false,
  }
};

const configReducer = (state = defaultState, action: any) => {
  const { isLoadingConfig, permission, generalConfig, notificationConfig, systemConfig, landingPageConfig, navMenuConfig } = action;

  switch (action.type) {
    case ConfigTypes.SET_SYSTEM_CONFIG_SUCCESS:
      return {
        ...state, 
        systemConfig: {
          dateTimeFormat: systemConfig?.dateTimeFormat,
        }
      }
    
    case ConfigTypes.SET_LOADING: 
      return {
        ...state,
        isLoadingConfig,
      }

    case ConfigTypes.SET_PERMISSION_CONFIG_SUCCESS:
      return {
        ...state,
        permission,
        isLoadingConfig: false,
      }
      
    case ConfigTypes.GET_GENERAL_CONFIG_SUCCESS:
      return {
        ...state,
        generalConfig: {
          ...state.generalConfig,
          ...generalConfig,
        },
      }
      
    case ConfigTypes.GET_NOTIFICATION_CONFIG_SUCCESS:
      return {
      ...state,
      notificationConfig
    }

    case ConfigTypes.GET_STATIC_PAGE_CONFIG_SUCCESS:
      return {
      ...state,
      landingPageConfig
    }

    case ConfigTypes.GET_NAV_MENU_CONFIG_SUCCESS:
      return {
        ...state,
        navMenuConfig,
      }
  }
  return state;
};

export default configReducer;
